import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const HqRoute: Route = {
  path: 'hq',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/overview.component').then((m) => m.HqOverviewComponent),
    },
    {
      path: ':branchId',
      loadComponent: () => import('./pages/details.component').then((m) => m.HqDetailsComponent),
    },
    {
      path: ':branchId/incident/:incidentId',
      loadComponent: () => import('./pages/details/incident-details.component').then((m) => m.IncidentDetailsComponent),
    },
    {
      path: ':branchId/request/:requestId',
      loadComponent: () => import('./pages/details/request-details.component').then((m) => m.RequestDetailsComponent),
    },
    {
      path: ':branchId/request/:requestId/activity/:activityId',
      loadComponent: () => import('./pages/details/activity-details.component').then((m) => m.ActivityDetailsComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
